const WEIGHTS = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
const MODULUS = 89;
/**
 * Normalises a string to 11 digits only (strips spaces, dashes, dots, underscores).
 * Returns empty string if result is not exactly 11 digits.
 */
export const normalizeABN = (abn) => {
    if (abn == null)
        return "";
    const digits = String(abn).replace(/[\s\-._]/g, "");
    return digits.length === 11 && /^\d+$/.test(digits) ? digits : "";
};
function checksumValid(digits) {
    const d = digits.split("").map(Number);
    d[0] -= 1;
    const sum = d.reduce((acc, val, i) => acc + val * WEIGHTS[i], 0);
    return sum % MODULUS === 0;
}
/**
 * Validates an Australian Business Number using the official modulus-89 algorithm.
 * Accepts null/undefined (returns false).
 */
export const validateABN = (item) => {
    const digits = normalizeABN(item);
    if (digits.length !== 11)
        return false;
    return checksumValid(digits);
};
/**
 * Returns true if the ABN is in the allowed list (after normalisation), or if no list/empty list.
 */
export const isABNInAllowlist = (abn, allowedAbns) => {
    if (!allowedAbns || allowedAbns.length === 0)
        return true;
    if (!abn)
        return false;
    const normalized = normalizeABN(abn);
    if (!normalized)
        return false;
    const normalizedList = allowedAbns.map((a) => normalizeABN(a));
    return normalizedList.includes(normalized);
};
/**
 * Generates a random 11-digit string that passes ABN checksum validation (for tests/E2E).
 */
export const generateValidABN = () => {
    let digits;
    do {
        digits = Array.from({ length: 11 }, () => Math.floor(Math.random() * 10));
    } while (!checksumValid(digits.join("")));
    return digits.join("");
};
